<template>
    <div class="categorieslist">
	
        <div  style="width:240px;">
          
            
			  <div>
				<VueSlickCarousel  :arrows="false" :dots="true" :autoplay="true" :autoplaySpeed="1000" :focusOnSelect="true" :pauseOnHover="false" >
				  <b-col class="product--img-wrapper m-0 p-0"  v-for="(data,index) in galleryimagesList" :key="index" >
				 
				 <!-- <b-img-lazy v-bind="mainProps" class=" circle border border-purple rounded-circle" :src="$root.MEDIAPATH+'banners/category/'+data" fluid ></b-img-lazy> -->
				  <!--<b-img-lazy   v-bind="mainProps" :src="$root.MEDIAAPI+'tool/get_image?size=540x450&src='+$root.MEDIAPATH+'banners/kiwikkrrush/'+data" fluid  alt="Responsive image" ></b-img-lazy>-->
				   <a :href="product_slug">
				   <b-img-lazy  v-if="data!=''"  v-bind="thumbnailProps" blank-color="#f7f7f7" 
						:src="$root.MEDIAAPI+'toolimage/get_image?size='+phoneImageWidth+'x'+phoneImageHeight+'&src='+data"
						 class="fluid "></b-img-lazy>
				  </a>
				   
				  
				  </b-col>
				 
				</VueSlickCarousel>
				 <ul v-if="galleryimagesList.length==1" data-v-3d1a4f76="" class="slick-dots" style="display: block;"> <li class=""><button>1</button></li></ul>
			  </div>

        </div> 
    </div>
</template>
<script>
 
import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    name: 'HeroCarousel',
	props: {
		 galleryimages: { type: Array },
		 phoneImageWidth:{type:String},
		 phoneImageHeight:{type:String},
		 product_slug:{type:String}
	 },
	 computed: {
		 galleryimagesList: function () {
				return this.galleryimages.filter(el => {
				  return el != null && el != '';
				});
				//console.log(arrFiltered);
		}
	 },
    components: {VueSlickCarousel},
    data() {
        return { 
			thumbnailProps: { blank: false, fluidGrow: true, width: 239, height:254,class: 'm1' },
            mainProps: { class: 'm1', center: true,blankColor: '#fff',width:284,height:284},
            settings: {			
                "arrows": false,
                "dotsClass": "slick-dots custom-dot-class",
                "edgeFriction": 0.35,
                "infinite": true,
                "autoplay": true,
                "speed": 500,
                "cssEase": "linear",
                "slidesToShow": 1,
                "slidesToScroll": 1,
                "responsive": [
					{
					  "breakpoint": 1024,
					  "settings": {
						"slidesToShow": 3,
						"slidesToScroll": 3,
						"infinite": true,
						"dots": true
					  }
					},
					{
					  "breakpoint": 600,
					  "settings": {
						"slidesToShow": 2,
						"slidesToScroll": 2,
						"initialSlide": 2
					  }
					},
					{
					  "breakpoint": 480,
					  "settings": {
						"slidesToShow": 1,
						"slidesToScroll": 1
					  }
					}
				  ]
            },
			bannerItems:[		 
			 //{img:"Fashion.png",title:"Fashion",url:"/fashion"},
			 {img:"Saree.png",title:"Saree",url:"/sarees"},
			 {img:"Cosmetics.png",title:"Cosmetics",url:"/cosmetics"},
			 {img:"Skin-Care.png",title:"Skin Care",url:"/skin-care"},
			 {img:"Hair-Care.png",title:"Hair Care",url:"/hair-care"},
			 {img:"Mens-Fashion.png",title:"Men's Fashion",url:"/men"},
			 {img:"Womens-Fashion.png",title:"Women's Fashion",url:"/women"},
			 {img:"lehenga.png",title:"Lehenga",url:"/lehenga-choli"},
			 {img:"Kurti.png",title:"Kurti",url:"/kurtis-tops"},
			 {img:"Makeup.png",title:"Makeup",url:"/makeup"},
			 {img:"Handbags&Clutches.png",title:"Handbags & Clutches",url:"/handbags-clutches"},
			 {img:"jewellery.png",title:"Jewellery ",url:"/women-jewellery"},
			 {img:"Womens-Shoes.png",title:"Women's Shoes",url:"/women-shoes"},
			 {img:"Mens-Shoes.png",title:"Men's Shoes",url:"/men-footwear"},
			 {img:"Accessories.png",title:"Accessories",url:"/women-accessories"}
			 ],
			
        }
    },
}
</script>
<style lang="scss">
.categorieslist{
.img-fluid{
			height:254px !important;
		 }
		}
		/* .slick-slide{
						outline: none;
						justify-content: center !important;
						display: flex !important;
					} */
					
					.slick-dots {
						position: absolute;
						bottom: -21px;
						display: block;
						width: 100%;
						
						padding: 0;
						margin: 0;
						height: 51px;
						list-style: none;
						text-align: center;
						background: #fff;
						
						li{
							width: 5px;
							button{
								 height: 45px;
							} 
						}
					}
</style>